module.exports = __webpack_public_path__ + "img/certificate_1.9267b4b9.jpg";